import {REST_METHODS} from '@/src/app/constants/api';
import authorizedFetch from '@/src/app/utils/authorizedFetch';

/**
 * @param {number} courseId
 * @param {number} rating
 * @param {string} comment
 */
const sendNewReview = (courseId, rating, comment) => {
  const body = {
    course_translation_id: courseId,
    comment: comment,
    score: rating,
  };

  // @ts-ignore
  return authorizedFetch({
    method: REST_METHODS.POST,
    path: `/api/v1/courses/ratings`,
    body,
  });
};

export default sendNewReview;
